export default __webpack_public_path__ + "static/The Right Time To Find A New Mattress-83d4cf42d9afa5a98a09bc4a684362ad.jpg";